import React, { FC } from 'react';
import { StorageData, useStorage } from '~Components/Storage';

import HandySettingsBlock, { SettingBlockItemType } from './HandySettingsBlock';
import { useDeviceHandler } from '~Components/DeviceProvider';

export interface Setting {
  key: keyof StorageData;
  label: string;
  description?: string;
}

type Props = {
  settingList: Setting[];
};

const SettingsToggle: FC<Props> = ({ settingList }) => {
  const deviceHandler = useDeviceHandler();
  const [storage, updateStorage] = useStorage();

  const handleStorageToggle = (key: keyof StorageData, value: boolean) => {
    updateStorage({
      [key]: value,
    });
  };

  const blocks: SettingBlockItemType[] = [
    ...settingList.map((setting) => ({
      id: setting.key,
      isRemotelyControlled: Boolean(deviceHandler.remotelyControlledData[setting.key]),
      title: setting.label,
      additionalText: {
        left: setting.description,
      },
      action: {
        isToggle: true,
        selected: storage[setting.key] as boolean,
        onClick: () => handleStorageToggle(setting.key, !storage[setting.key]),
      },
    })),
  ];

  return <HandySettingsBlock items={blocks} />;
};

export default SettingsToggle;
